import React, { Component } from "react";
import "./PlanSuggestionQuestionDataUse.css";

import MediaQuery from "react-responsive";
import DataUseSlider from "./DataUseSlider";

class PlanSuggestionQuestionDataUse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      music: 1,
      socialMedia: 1,
      streaming: 1,
      gaming: 1,
    };

    this.onQuestionNext = this.props.onQuestionNext.bind(this);
    this.onQuestionBack = this.props.onQuestionBack.bind(this);
  }

  getDataUse() {
    const { music, socialMedia, streaming, gaming } = this.state;
    return music * 2 + streaming * 12 + socialMedia * 1 + gaming * 3;
  }

  getDataUseLabel() {
    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const dataUse = this.getDataUse();
    let dataUseLabel = dataUse > 50 ? "50+" : dataUse;
    return lang === "tc"
      ? `預計每月數據用量：${dataUseLabel}GB`
      : `Estimated monthly data usage: ${dataUseLabel}GB`;
  }

  handleChangeMusicSlider(value) {
    this.setState({ music: value });
  }

  handleAfterChangeMusicSlider(value) {
    let trackingId;

    switch (value) {
      case 1:
      default:
        trackingId = "S3_M30";
        break;
      case 2:
        trackingId = "S3_M60";
        break;
      case 3:
        trackingId = "S3_M90";
        break;
      case 4:
        trackingId = "S3_M120";
        break;
      case 5:
      case 5.1:
        trackingId = "S3_M180";
        break;
    }

    window.trackCustomLink(`Online Acq. Select Plan Section | ${trackingId}`);
  }

  handleChangeSocialMediaSlider(value) {
    this.setState({ socialMedia: value });
  }

  handleAfterChangeSocialMediaSlider(value) {
    let trackingId;

    switch (value) {
      case 1:
      default:
        trackingId = "S3_S30";
        break;
      case 2:
        trackingId = "S3_S60";
        break;
      case 3:
        trackingId = "S3_S90";
        break;
      case 4:
        trackingId = "S3_S120";
        break;
      case 5:
      case 5.1:
        trackingId = "S3_S180";
        break;
    }

    window.trackCustomLink(`Online Acq. Select Plan Section | ${trackingId}`);
  }

  handleChangeStreamingSlider(value) {
    this.setState({ streaming: value });
  }

  handleAfterChangeStreamingSlider(value) {
    let trackingId;

    switch (value) {
      case 1:
      default:
        trackingId = "S3_V30";
        break;
      case 2:
        trackingId = "S3_V60";
        break;
      case 3:
        trackingId = "S3_V90";
        break;
      case 4:
        trackingId = "S3_V120";
        break;
      case 5:
      case 5.1:
        trackingId = "S3_V180";
        break;
    }

    window.trackCustomLink(`Online Acq. Select Plan Section | ${trackingId}`);
  }

  handleChangeGamingSlider(value) {
    this.setState({ gaming: value });
  }

  handleAfterChangeGamingSlider(value) {
    let trackingId;

    switch (value) {
      case 1:
      default:
        trackingId = "S3_G30";
        break;
      case 2:
        trackingId = "S3_G60";
        break;
      case 3:
        trackingId = "S3_G90";
        break;
      case 4:
        trackingId = "S3_G120";
        break;
      case 5:
      case 5.1:
        trackingId = "S3_G180";
        break;
    }

    window.trackCustomLink(`Online Acq. Select Plan Section | ${trackingId}`);
  }

  render() {
    const { data } = this.props;
    const { music, socialMedia, streaming, gaming } = this.state;


    const {
      headerTc,
      headerEn,
      questionTc,
      questionEn,
      questionRemarkTc,
      questionRemarkEn,
      trackingIdBack,
      trackingIdNext,
    } = data;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const header = lang === "tc" ? headerTc : headerEn;
    const question = lang === "tc" ? questionTc : questionEn;
    const questionRemark = lang === "tc" ? questionRemarkTc : questionRemarkEn;

    const labelBack = lang === "tc" ? "上一步" : "Back";
    const labelNext = lang === "tc" ? "下一步" : "Next";

    const dataUse = this.getDataUse();

    return (
      <div className="card-question-data-use">
        <div className="header">{header}</div>

        <div className="body">
          <div className="question">{question}</div>
          <div class="question-remark">{questionRemark}</div>

          <div className="container-options">
            <MediaQuery minWidth={768}>
              <div className="row">
                <div className="col-xs-6">
                  <DataUseSlider
                    type={"music"}
                    style={{ marginTop: "0" }}
                    onChange={(value) => this.handleChangeMusicSlider(value)}
                    onAfterChange={(value) =>
                      this.handleAfterChangeMusicSlider(value)
                    }
                  />
                </div>
                <div className="col-xs-6 pr-data-use-slider">
                  <DataUseSlider
                    type={"social-media"}
                    style={{ marginTop: "0" }}
                    onChange={(value) =>
                      this.handleChangeSocialMediaSlider(value)
                    }
                    onAfterChange={(value) =>
                      this.handleAfterChangeSocialMediaSlider(value)
                    }
                  />
                </div>
                <div className="col-xs-6 mt-data-use-slider">
                  <DataUseSlider
                    type={"streaming"}
                    onChange={(value) =>
                      this.handleChangeStreamingSlider(value)
                    }
                    onAfterChange={(value) =>
                      this.handleAfterChangeStreamingSlider(value)
                    }
                  />
                </div>
                <div className="col-xs-6 mt-data-use-slider pr-data-use-slider">
                  <DataUseSlider
                    type={"gaming"}
                    onChange={(value) => this.handleChangeGamingSlider(value)}
                    onAfterChange={(value) =>
                      this.handleAfterChangeGamingSlider(value)
                    }
                  />
                </div>
              </div>
            </MediaQuery>

            <MediaQuery maxWidth={767.98}>
              <div className="row">
                <div className="col-xs-12 pr-data-use-slider">
                  <DataUseSlider
                    type={"music"}
                    onChange={(value) => this.handleChangeMusicSlider(value)}
                    onAfterChange={(value) =>
                      this.handleAfterChangeMusicSlider(value)
                    }
                  />
                </div>
                <div className="col-xs-12 mt-data-use-slider pr-data-use-slider">
                  <DataUseSlider
                    type={"social-media"}
                    onChange={(value) =>
                      this.handleChangeSocialMediaSlider(value)
                    }
                    onAfterChange={(value) =>
                      this.handleAfterChangeSocialMediaSlider(value)
                    }
                  />
                </div>
                <div className="col-xs-12 mt-data-use-slider pr-data-use-slider">
                  <DataUseSlider
                    type={"streaming"}
                    onChange={(value) =>
                      this.handleChangeStreamingSlider(value)
                    }
                    onAfterChange={(value) =>
                      this.handleAfterChangeStreamingSlider(value)
                    }
                  />
                </div>
                <div className="col-xs-12 mt-data-use-slider pr-data-use-slider">
                  <DataUseSlider
                    type={"gaming"}
                    onChange={(value) => this.handleChangeGamingSlider(value)}
                    onAfterChange={(value) =>
                      this.handleAfterChangeGamingSlider(value)
                    }
                  />
                </div>
              </div>
            </MediaQuery>

            <div className="label-data-usage">{this.getDataUseLabel()}</div>
          </div>

          <div class="container-button-group">
            <button
              className="btn-outline-transparent"
              onClick={() => {
                window.trackCustomLink(
                  `Online Acq. Select Plan Section | ${trackingIdBack}`
                );
                this.onQuestionBack();
              }}
            >
              {labelBack}
            </button>

            <button
              className="btn-outline-transparent"
              onClick={() => {
                window.trackCustomLink(
                  `Online Acq. Select Plan Section | ${trackingIdNext}`
                );

                this.state = {
                  music: 1,
                  socialMedia: 1,
                  streaming: 1,
                  gaming: 1,
                };

                this.onQuestionNext({
                  dataUse,
                  music, 
                  socialMedia, 
                  streaming, 
                  gaming
                });
              }}
            >
              {labelNext}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default PlanSuggestionQuestionDataUse;
